// ═══════════════════════════════════════════════════════════════════════════════
// Usage metric card — settings & usage page
// ═══════════════════════════════════════════════════════════════════════════════

type UsageMetricCardProps = {
  title: string;
  hint: string;
  used: number;
  limit: number | null;
  loading?: boolean;
  resetAt?: string;
  resetAtLabel?: string;
  unlimitedLabel?: string;
  loadingLabel?: string;
};

const formatUsageFraction = (
  used: number,
  limit: number | null,
  unlimitedLabel: string,
): string => {
  if (limit === null) {
    return `${used}/${unlimitedLabel}`;
  }
  return `${used}/${limit}`;
};

export const UsageMetricCard = ({
  title,
  hint,
  used,
  limit,
  loading = false,
  resetAt,
  resetAtLabel,
  unlimitedLabel = '∞',
  loadingLabel = '…',
}: UsageMetricCardProps) => (
  <div
    className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-3 dark:border-gray-700 dark:bg-gray-800/60"
    role="region"
    aria-label={title}
  >
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-200">{title}</p>
        <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{hint}</p>
        {resetAt && resetAtLabel ? (
          <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">
            {resetAtLabel}: {resetAt}
          </p>
        ) : null}
      </div>
      <p className="shrink-0 text-base font-semibold text-primary-700 dark:text-primary-300">
        {loading ? loadingLabel : formatUsageFraction(used, limit, unlimitedLabel)}
      </p>
    </div>
  </div>
);
